import i18n from 'src/i18n'

import {
  Typography,
  TypographyVariant,
  TypographyWeight,
} from 'src/components/atoms'

import { OAuthProvider } from 'src/app/auth/interfaces'

import { AuthBackgroundVideo } from './components/auth-background-video'
import { LoginProviderModal } from './components/login-provider-modal'

export interface ILoginTemplateProps {
  onProviderSignIn: (provider: OAuthProvider) => void
  loadingProvider?: OAuthProvider
}

export const LoginTemplate = ({
  onProviderSignIn,
  loadingProvider,
}: ILoginTemplateProps): JSX.Element => {
  return (
    <main className="relative min-h-dvh w-full overflow-hidden bg-content-primary text-surface-raised">
      <AuthBackgroundVideo />

      <div aria-hidden className="absolute inset-0 bg-black/40" />

      <div className="relative flex min-h-dvh flex-col px-6 py-10 md:px-[120px] md:py-[100px]">
        <section className="flex flex-1 items-center">
          <div className="flex w-full max-w-[461px] flex-col gap-6">
            <Typography
              variant={TypographyVariant.bodyXxsStrong}
              className="uppercase tracking-[0.04em] text-surface-muted"
            >
              {i18n.t('auth.login.title')}
            </Typography>

            <Typography
              variant={TypographyVariant.display}
              weight={TypographyWeight.regular}
              className="font-display leading-none text-surface-raised"
            >
              {i18n.t('brand.name')}
            </Typography>

            <Typography
              variant={TypographyVariant.bodyXl}
              weight={TypographyWeight.light}
              className="leading-normal text-surface-raised"
            >
              {i18n.t('auth.login.subtitle')}
            </Typography>

            <LoginProviderModal
              onProviderSignIn={onProviderSignIn}
              loadingProvider={loadingProvider}
            />
          </div>
        </section>

        <footer className="pt-10">
          <Typography
            variant={TypographyVariant.bodyXxs}
            className="text-surface-muted"
          >
            {i18n.t('auth.login.rightsReserved', {
              year: new Date().getFullYear(),
            })}
          </Typography>
        </footer>
      </div>
    </main>
  )
}
